var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"px-6 py-4 rounded overflow-hidden shadow select-none"},[_vm._v(" "+_vm._s(_vm.rank)+" - "+_vm._s(_vm.value)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }